var RebindEvent = function () {
  function RebindEvent() {}

  return RebindEvent;
}();

export { RebindEvent };
export var RebindEventType;

(function (RebindEventType) {
  RebindEventType[RebindEventType["AUTH_EVENT"] = 0] = "AUTH_EVENT";
})(RebindEventType || (RebindEventType = {}));